import React, { useEffect, useState } from "react";
import useSelectorId from "../../../../../utilities/hooks/useSelectorId";
import {
   endpointRequest,
   updateServerSession,
} from "../../../../../utilities/requests";
import ECLDropDown from "../../../../Widgets/ECLDropDown/ECLDropDown";
import ECLThemeImage from "../../../../Widgets/ECLThemeImage/ECLThemeImage";
import TableNumericRangeFilter from "../../../../Widgets/ECLTable/widgets/TableNumericRangeFilter";
import TableStringFilter from "../../../../Widgets/ECLTable/widgets/TableStringFilter";

export default function ExplorerFilter(props) {
   const [filterData, setFilterData] = useState(null);
   const instanceID = useSelectorId();
   const rootId = props.headlist.at(-1);
   const sessionId = props.flatDoc[rootId].session;

   useEffect(() => {
      endpointRequest(
         props.parentObject,
         props.block.id,
         sessionId,
         props.filterName,
      )
         .then((res) => {
            let min;
            let max;
            if (filterData) {
               min = filterData.state[0];
               max = filterData.state[1];
            } else {
               min = res.rows[0][0];
               max = res.rows[0][1];
            }
            if (props.endpoint === "Numeric Properties") {
               // Hardcoded way of getting the min and max values for now
               setFilterData({
                  data: res,
                  precision: res.columns[0].type.precision,
                  state: [min, max],
                  defaults: [res.rows[0][0], res.rows[0][1]],
               });
            } else {
               //Set up state like the eclselect examples
               const newState = {
                  data: res,
                  state: res.rows.map((row) => {
                     return {
                        id: row[0],
                        searchableString: String(row[0]),
                        jsx: String(row[0]),
                        selected: true,
                     };
                  }),
               };
               setFilterData(newState);
            }
         })
         .catch((error) => {
            console.error(error);
         });
   }, []);

   if (filterData === null) {
      return null;
   }

   function handleNumerics(rangeArray) {
      const key_vals = [
         {
            key: props.filterName,
            value: {
               filter: {
                  min: rangeArray[0],
                  max: rangeArray[1],
               },
            },
         },
      ];
      setFilterData((d) => {
         return {
            ...d,
            state: rangeArray,
         };
      });
      updateServerSession(props, key_vals);
   }

   function clearNumerics() {
      const key_vals = [
         {
            key: props.filterName,
            value: {
               filter: {
                  min: filterData.defaults[0],
                  max: filterData.defaults[1],
               },
            },
         },
      ];
      setFilterData((d) => {
         return {
            ...d,
            state: [filterData.defaults[0], filterData.defaults[1]],
         };
      });
      updateServerSession(props, key_vals);
   }

   async function handleCategoryFilter(items) {
      let key_vals = [];
      key_vals.push({
         key: props.filterName,
         value: {
            filter: {
               selections: items
                  .filter((s) => s.selected)
                  .map((s) => s.searchableString),
            },
         },
      });
      // This doesn't work due to update server session causing you to get a fresh Explorer Filter component, this state will be automatically refreshed
      setFilterData((prevState) => {
         return {
            ...prevState,
            state: items,
         };
      });
      updateServerSession(props, key_vals);
   }

   async function clearCategoryFilter(category) {
      let key_vals = [];
      key_vals.push({
         key: category,
         value: {
            filter: props.filterName,
            selections: [""],
         },
      });
      updateServerSession(props, key_vals);
   }

   if (props.endpoint === "Numeric Properties") {
      return (
         <div>
            <ECLDropDown
               id={"numeric-filter" + instanceID}
               menuWidth={275}
               trigger={<ECLThemeImage fontAwesome="filter" />}
            >
               <TableNumericRangeFilter
                  defaultValueMin={filterData.state[0]}
                  defaultValueMax={filterData.state[1]}
                  min={filterData.defaults[0]}
                  max={filterData.defaults[1]}
                  precision={filterData.precision}
                  setRangeFunction={handleNumerics}
                  clearRangeFunction={clearNumerics}
               />
            </ECLDropDown>
         </div>
      );
   } else if (props.filterName === "id") {
      return null;
   } else {
      return (
         <TableStringFilter
            options={filterData.state}
            customTrigger={<ECLThemeImage fontAwesome={"filter"} />}
            setFilterFunction={handleCategoryFilter}
            clearFilterFunction={clearCategoryFilter}
         />
      );
   }
}
